import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { ICostingLevel } from '../../../../models/costing-level.model';
import { Observable } from 'rxjs';
import { ICostingLevelLayout } from '../../../../models/layout/costing-level-layout.model';
import { ICostingLevelsState } from '../../../../services/facades/master-data/costing-levels-state.model';
import { CostingLevelsFacade } from '../../../../services/facades/master-data/costing-levels.facade';
import { CostingLevelLayoutService } from '../../../../services/layout/costing-level-layout.service';

@Component({
    selector: 'app-cost-center-dialog',
    templateUrl: './costing-level-dialog.component.html',
    styleUrls: [ './costing-level-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostingLevelDialogComponent implements OnInit, AfterViewInit {
    public costCenterState$: Observable<ICostingLevelsState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;
    public isSubordinate: boolean = false;
    public layout: ICostingLevelLayout;


    constructor(
        private myMatDialogRef: MatDialogRef<CostingLevelDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostingLevel,
        private myCostCenterFacade: CostingLevelsFacade,
        private myCostingLevelLayoutService: CostingLevelLayoutService
    ) {
    }

    public ngOnInit(): void {
        this.costCenterState$ = this.myCostCenterFacade.subState();
        this.layout = this.myCostingLevelLayoutService.getCostingLevelDialogLayout();
        if (!isNullOrUndefined(this.data)) {
            isNullOrUndefined(this.data.parentCostingLevelId) ? this.isSubordinate = false : this.isSubordinate = true;
        }
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((costingLevel: ICostingLevel) => {
            this.validateDialogFields(costingLevel);
        });
    }

    public async save(): Promise<void> {
        const data: ICostingLevel = this.formGroup.value as ICostingLevel;
        if (isNullOrUndefined(this.data.id)) {
            await this.myCostCenterFacade.addKalkstufe(data);
        } else {
            data.id = this.data.id;
            await this.myCostCenterFacade.editKalkstufe(data);
        }
        this.myMatDialogRef.close(true);

    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(costingLevel: ICostingLevel): void {
        // Validations to disable saving/editing
        if (isNullOrUndefined(costingLevel.name)
            || (!isNullOrUndefined(costingLevel.parentCostingLevelId) && !isNullOrUndefined(costingLevel.costingLevelType))) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
